"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebpackPrecompiledLoader = WebpackPrecompiledLoader;

function WebpackPrecompiledLoader(precompiled = {}) {
  this.precompiled = precompiled;
}

WebpackPrecompiledLoader.prototype.getSource = function getSource(name) {
  if (!(name in this.precompiled)) {
    return null;
  }

  return {
    src: {
      type: 'code',
      obj: this.precompiled[name]
    },
    path: name
  };
};